/* @flow strict */

/* eslint-disable camelcase */

import * as React from 'react';
import MapSectionHeader from './MapSectionHeader';
import Autocomplete from 'react-google-autocomplete';
import MapTicket from '../../ticketSections/map';
import _ from 'lodash';

type PropsType = {
  onHandleChangeMap: () => void,
  editablePart?: any
};

const MapModal = (props: PropsType): React.Element => {
  const { onHandleChangeMap, editablePart } = props;
  const [autocomplete, setAutocomplete] = React.useState({ formatted_address : _.get(editablePart, 'address') });
  const AutocompleteRef = React.useRef(null);

  const handleChangeSearchInputValue = (value: string) => {
    setAutocomplete({
      formatted_address: value
    });
  };

  const lat = autocomplete.geometry ? autocomplete.geometry.location.lat() : _.get(editablePart, 'lat', 0);
  const lng = autocomplete.geometry ? autocomplete.geometry.location.lng() : _.get(editablePart, 'lng', 0);
  const map_zoom = _.get(editablePart, 'map_zoom', 9);
  const background_color = _.get(editablePart, 'background_color', 'Light');

  return (
    <>
      <MapSectionHeader {...props} onHandleChange={onHandleChangeMap} title={'Map'} />

      <div className="row">
        <div className="col-xs-12">
          <div className="form-group SimpleInput LocAutocomplete" style={{ zIndex: 9 }}>
            <label htmlFor="eventLocation">Address</label>
            <Autocomplete
              ref={AutocompleteRef}
              className='form-control'
              style={{ width: '100%' }}
              placeholder=''
              onPlaceSelected={(place: {}) => {
                console.log('\n\n Map.jsx : 48 /--------------------------------');
                console.log(place);
                console.log('Map.jsx : 48 --------------------------------/\n\n');

                setAutocomplete(place);

                onHandleChangeMap({
                  address: place.formatted_address,
                  lat: place.geometry.location.lat(),
                  lng: place.geometry.location.lng()
                });
              }}
              types={['address']}
              value={autocomplete.formatted_address}
              onChange={(e: any) => {
                handleChangeSearchInputValue(e.target.value);
              }}
            />
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-xs-12">
          <MapTicket
            withoutEdit
            p={{
              lat,
              lng,
              map_zoom,
              background_color
             }}
            handleSetZoom={(map_zoom: number): void => onHandleChangeMap({ map_zoom })}
          />
        </div>
      </div>
    </>
  );
};

export default MapModal;